import { z } from 'zod';
import { ClientKnowledgeStatus, PostsProjectType } from '../constants';

export type ClientPostConfigTask = {
  id: string;
  label: string;
  userId: string;
  blockedBy?: string[];
  /** Task stays blocked until the post is approved (by the client). */
  blockedByPostApproval?: boolean;
};

export type CadenceRule =
  | { kind: 'weekday'; weekdays: string[] }
  | { kind: 'monthly'; targetPerMonth: number };

export type ProjectTypeConfig = {
  type: PostsProjectType;
  cadence: CadenceRule;
  /** Only meaningful for weekday cadence. */
  removedDays?: string[];
  checklist?: ClientPostConfigTask[];
};

export type ClientPostsConfig = {
  // Legacy fields — still the source of truth for PostsProjectType.POST until a
  // client has an explicit `projectTypes` entry for POST.
  weekdays?: string[];
  removedDays?: string[];
  checklist?: ClientPostConfigTask[];
  // Cadence config for deliverable types beyond the legacy default (e.g. LinkedIn
  // articles), and an optional override for POST itself.
  projectTypes?: ProjectTypeConfig[];
};

export const clientSchema = z.object({
  id: z.string(),
  name: z.string(),
  doc: z.string().nullable(),
  icon: z.string().nullable(),
  image: z.string().nullable(),
  ownerId: z.string().nullable(),
  postsConfig: z.custom<ClientPostsConfig>().nullable(),
  metadata: z.record(z.any()).nullable(),
  preferredTime: z.string().nullable().optional(),
  timezone: z.string(),
  knowledgeStatus: z.nativeEnum(ClientKnowledgeStatus),
  knowledge: z.string().nullable(),
  archived: z.boolean(),
  allowCaptionSuggestions: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ClientSchema = z.infer<typeof clientSchema>;
